import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import moment from '~/Providers/Moment';

import mParticle, { ScreenViewEvent } from '~/Providers/mParticle';
import Agenda from '~/Containers/Pages/Agenda/Agenda';
import PageSplit from '~/Components/Layout/PageSplit/PageSplit';
import { DEFAULT_TIME_ZONE, TABLET_WIDTH } from '~/Redux/Constants';
import { increment, decrement, setHabitMonth } from '~/Redux/Modules/DateRange';
import { handleSyncScroll } from '~/Components/Global/Scroll/SyncScroll';
import NoScrollBar from '~/Components/Global/NoScrollBar/NoScrollBar';
import { addResizeListener } from '~/Components/Global/Window/Resize';
import MonthNagivator from './MonthNavigator';
import DateHeader from './DateHeader';
import HabitsColumn from './HabitsColumn';
import './Habits.scss';
import HabitTrackingRow from './HabitTrackingRow';
import HabitContext from './HabitContext';
import MobileLayout from './MobileLayout';

class Habits extends Component {
  constructor() {
    super();
    this.currentDate = new Date();

    this.state = {
      width: false,
      scrollSet: false,
      habitState: {
        habitRows: [],
        placeholderRows: [],
        streaks: {},
        update: this.updateHabitState,
      },
    };
  }

  updateHabitState = newStateSlice => {
    this.setState({ habitState: { ...this.state.habitState, ...newStateSlice } });
  };

  componentDidMount = () => {
    addResizeListener(this);
    mParticle.logEvent(new ScreenViewEvent('Habits'));
    if (this.props.location.hash) {
      window.location.replace(this.props.location.hash);
    }
    const { match, setHabitMonth } = this.props;
    if (match.params.year || match.params.month) {
      const start = moment()
        .set('year', match.params.year)
        .set('month', match.params.month - 1);
      if (start.isValid()) {
        return setHabitMonth(start);
      }
      return setHabitMonth(moment());
    }
    return setHabitMonth(moment());
  };

  componentDidUpdate = (nextProps, nextState) => {
    // to handle resize if the with goes down to mobile we need to reset the left ref to the mobile span
    if (
      (nextState.width > TABLET_WIDTH && this.state.width < TABLET_WIDTH) ||
      (nextState.width < TABLET_WIDTH && this.state.width > TABLET_WIDTH)
    ) {
      this.setState({ scrollSet: false });
    }

    // activating scroll sync
    if (this.rightHabitRef && this.leftHabitRef && !this.state.scrollSet) {
      handleSyncScroll([
        this.leftHabitRef.getElementsByClassName('scroll-child')[0],
        this.rightHabitRef.getElementsByClassName('scroll-child')[0],
      ]);
      this.setState({ scrollSet: true });
    }
  };

  renderDesktopLayout = () => {
    if (this.state.width <= TABLET_WIDTH) return;
    const { start, increment, decrement, currentType, end, habits } = this.props;
    const currentYear = this.currentDate.getFullYear();
    const currentMonth = this.currentDate.getMonth() + 1; //Add 1 because months are zero based
    const isCurrentMonthAndYear =
      currentYear === start.year() && currentMonth === start.month() + 1;

    const formattedStartDate = start.format('MMMM YYYY');
    const daysInMonth = moment(start).daysInMonth();

    const leftDaysCount = 12;
    const rightDaysCount = daysInMonth - leftDaysCount;

    const leftDaysArray = Array.from({ length: leftDaysCount }, (_, index) => index + 1);
    const rightDaysArray = Array.from(
      { length: rightDaysCount },
      (_, index) => index + leftDaysCount + 1
    );
    return (
      <PageSplit leftClassName="habit-left-side" rightClassName="habit-right-side">
        <div className="left-side">
          <MonthNagivator
            formattedStartDate={formattedStartDate}
            decrement={decrement}
            increment={increment}
            start={start}
            end={end}
            currentType={currentType}
          />
          <div className="habit-grid-container-left">
            <div className="habit-column">HABITS</div>
            <DateHeader
              daysArray={leftDaysArray}
              position="left"
              isCurrentMonthAndYear={isCurrentMonthAndYear}
              currentDate={this.currentDate}
            />
          </div>
          <div className="habit-wrapper" ref={r => (this.leftHabitRef = r)}>
            <NoScrollBar showScrollOnHover>
              <div className="habit-grid-container-left">
                <HabitContext.Provider value={this.state.habitState}>
                  <HabitsColumn start={start} />
                  <div className="habit-tracking-column">
                    {this.state.habitState.habitRows.map(habit => (
                      <div key={`left_${habit.id}`}>
                        <HabitTrackingRow
                          daysArray={leftDaysArray}
                          position="left"
                          isCurrentMonthAndYear={isCurrentMonthAndYear}
                          currentDate={this.currentDate}
                          habit={habit}
                          start={start}
                        />
                      </div>
                    ))}
                    {this.state.habitState.placeholderRows.map((placeholder, index) => (
                      <div key={`left_placeholder_${index}`}>
                        <HabitTrackingRow
                          daysArray={leftDaysArray}
                          position="left"
                          isCurrentMonthAndYear={isCurrentMonthAndYear}
                          currentDate={this.currentDate}
                          start={start}
                        />
                      </div>
                    ))}
                  </div>
                </HabitContext.Provider>
              </div>
            </NoScrollBar>
          </div>
        </div>
        <div className="habit right-side">
          <div className="habit-grid-container-right">
            <DateHeader
              daysArray={rightDaysArray}
              position="right"
              isCurrentMonthAndYear={isCurrentMonthAndYear}
              currentDate={this.currentDate}
            />
            <div className="habit-wrapper" ref={r => (this.rightHabitRef = r)}>
              <NoScrollBar showScrollOnHover>
                <div className="habit-grid-container-right">
                  <div className="habit-tracking-column">
                    {this.state.habitState.habitRows.map(habit => (
                      <div key={`right_${habit.id}`}>
                        <HabitTrackingRow
                          daysArray={rightDaysArray}
                          position="right"
                          isCurrentMonthAndYear={isCurrentMonthAndYear}
                          currentDate={this.currentDate}
                          habit={habit}
                          start={start}
                        />
                      </div>
                    ))}
                    {this.state.habitState.placeholderRows.map((placeholder, index) => (
                      <div key={`right_placeholder_${index}`}>
                        <HabitTrackingRow
                          daysArray={rightDaysArray}
                          position="right"
                          isCurrentMonthAndYear={isCurrentMonthAndYear}
                          currentDate={this.currentDate}
                          start={start}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </NoScrollBar>
            </div>
          </div>
        </div>
      </PageSplit>
    );
  };

  renderMobileLayout = () => {
    if (this.state.width > TABLET_WIDTH) return;
    return <MobileLayout start={this.props.start} habitState={this.state.habitState} />;
  };

  render() {
    return (
      <Agenda isHabit>
        {this.renderDesktopLayout()}
        {this.renderMobileLayout()}
      </Agenda>
    );
  }
}

Habits.propTypes = {
  location: propTypes.object,
  match: propTypes.object,
  start: propTypes.object,
  end: propTypes.object,
  decrement: propTypes.func,
  increment: propTypes.func,
  currentType: propTypes.string,
  habits: propTypes.array,
  dispatch: propTypes.func,
  setHabitMonth: propTypes.func,
};

const mapStateToProps = ({ DateRange, Habits }) => {
  return {
    currentDay: DateRange.today,
    start: DateRange.start,
    end: DateRange.end,
    currentType: DateRange.currentType,
    habits: Habits.habitCollection.habits,
    userTimeZone: moment.tz.guess() || DEFAULT_TIME_ZONE,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    increment: (currentType, start) => dispatch(increment(currentType, start.clone())),
    decrement: (currentType, start) => dispatch(decrement(currentType, start.clone())),
    setHabitMonth: start => dispatch(setHabitMonth(start.clone())),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Habits);
